import React from 'react';
import get from 'lodash/get';

import imgDocs3x from '../../assets/images/doc_documents@3x.png';
import imgPres3x from '../../assets/images/doc_presentation@3x.png';
import imgRisk3x from '../../assets/images/doc_risks@3x.png';
import imgSumm3x from '../../assets/images/doc_summary@3x.png';
import imgDocs2x from '../../assets/images/doc_documents@2x.png';
import imgPres2x from '../../assets/images/doc_presentation@2x.png';
import imgRisk2x from '../../assets/images/doc_risks@2x.png';
import imgSumm2x from '../../assets/images/doc_summary@2x.png';
import imgDocs from '../../assets/images/doc_documents.png';
import imgPres from '../../assets/images/doc_presentation.png';
import imgRisk from '../../assets/images/doc_risks.png';
import imgSumm from '../../assets/images/doc_summary.png';

import { LAYOUT } from '../Layout/enums';

import './OfferDocuments.css';

const docsMenu = [
  {
    name: 'Investor Presentation',
    image: imgPres,
    image2x: imgPres2x,
    image3x: imgPres3x,
    prop: 'investorPresentation',
  },
  {
    name: 'Offering Summary',
    image: imgSumm,
    image2x: imgSumm2x,
    image3x: imgSumm3x,
    prop: 'offeringSummary',
  },
  {
    name: 'Offering Documents',
    image: imgDocs,
    image2x: imgDocs2x,
    image3x: imgDocs3x,
    prop: 'offeringDocuments',
  },
  {
    name: 'Risk Factors',
    image: imgRisk,
    image2x: imgRisk2x,
    image3x: imgRisk3x,
    prop: 'riskFactors',
  },
];

const OfferDocuments = ({ documents, layout }) => {
  let styleSuff = '';
  let imgSize = '3x';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      imgSize = '2x';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      imgSize = '';
      break;
    // no default
  }
  return (
    <div>
      <div styleName="offerDocuments">
        {docsMenu.map((item) => {
          const docUrl = get(documents, item.prop, null);
          return (
            docUrl ?
              <a styleName="docItem" key={item.name} href={docUrl} target="_blank">
                <img styleName={`docImg${styleSuff}`} src={item[`image${imgSize}`]} alt={item.name} />
                <div styleName={`docName${styleSuff}`}>{item.name}</div>
              </a> : null);
        })}
      </div>
    </div>
  );
};

export default OfferDocuments;



// WEBPACK FOOTER //
// ./src/components/Offering/OfferDocuments.js